import { combineReducers } from "redux";

import list from "./List/reducer";
import view from "./View/reducer";

const flagsReducer = combineReducers({
  list,
  view,
});

export default flagsReducer;
